import { createContext } from "react"
import { Dimensions, Platform } from "react-native"

export const WINDOW_WIDTH =
    Platform.OS !== "web"
        ? Dimensions.get("window").width
        : Dimensions.get("window").width > 800
        ? (Dimensions.get("window").width * 2) / 3
        : Dimensions.get("window").width
export const WINDOW_HEIGHT = Dimensions.get("window").height

export const IS_WEB = Platform.OS === "web"
export const IS_CALLKEEP_COMPATIBLE = !IS_WEB // && (Platform.OS === "ios" || !!DeviceInfo.getCarrier())
export const IS_BIG = Dimensions.get("window").width > 800
export const isWebMobile = () => {
    let details = navigator.userAgent
    let regexp = /android|iphone|kindle|ipad/i

    return regexp.test(details)
}
export const isSafari = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    return userAgent.includes("safari") && !userAgent.includes("chrome")
}

export const isChrome = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    return (
        userAgent.includes("chrome") &&
        !userAgent.includes("opr") &&
        !userAgent.includes("edg")
    )
}

export const NavigationRefContext = createContext()

export const DimensionsContext = createContext()
export const isMobile = () => {
    let details = navigator.userAgent
    let regexp = /android|iphone|kindle|ipad/i

    return regexp.test(details)
}
